import layerService from '@/services/layer-service'
import { getModeToggleableLayers } from '@/components/map-controls/control-layers/utils'
import { WIND_LAYER_INFO } from '@/fish/components/map-controls/utils'

interface ResolvedLayer {
  id: string
  label: string
  img: string
  fullImg: string
  component: string
  hasAccess: boolean
  active?: boolean
}

export function resolveLayerById(
  id: string,
  mode: string
): ResolvedLayer | null {
  if (id === WIND_LAYER_INFO.id) {
    return WIND_LAYER_INFO
  }

  const staticLayer = getModeToggleableLayers(mode, 'fish').find(
    (layer: { id: string }) => layer.id === id
  )

  if (!staticLayer) {
    return null
  }

  return { ...staticLayer, ...layerService.getLayer(id) }
}
